import React, { useEffect, useRef, useState, useCallback } from 'react';
import { Html5Qrcode } from 'html5-qrcode';

function BarcodeScanner({ onScan, onClose }) {
  const [error, setError] = useState('');
  const scannerRef = useRef(null);
  const isStoppingRef = useRef(false);

  // Cleanup function to properly stop scanner and fix iOS focus issues
  const cleanupScanner = useCallback(async () => {
    if (isStoppingRef.current || !scannerRef.current) return;
    isStoppingRef.current = true;

    try {
      const scanner = scannerRef.current;

      // Stop the scanner
      await scanner.stop();

      // Clear the scanner UI - important for iOS
      await scanner.clear();
    } catch (err) {
      console.error('Failed to cleanup scanner', err);
    }

    // Fix iOS focus issues by blurring active element and resetting focus
    if (document.activeElement) {
      document.activeElement.blur();
    }

    // Small delay to let iOS recover focus state
    await new Promise(resolve => setTimeout(resolve, 100));

    isStoppingRef.current = false;
  }, []);

  useEffect(() => {
    const html5QrCode = new Html5Qrcode('reader');
    scannerRef.current = html5QrCode;

    const config = {
      fps: 10,
      qrbox: { width: 250, height: 250 },
      aspectRatio: 1.0,
    };

    html5QrCode
      .start(
        { facingMode: 'environment' },
        config,
        async (decodedText) => {
          await cleanupScanner();
          onScan(decodedText);
        },
        (errorMessage) => {
          // Ignore scan errors
        }
      )
      .catch((err) => {
        setError('Unable to access camera. Please check permissions.');
        console.error(err);
      });

    return () => {
      cleanupScanner();
    };
  }, [cleanupScanner, onScan]);

  const handleClose = async () => {
    await cleanupScanner();
    onClose();
  };

  return (
    <div className="card">
      <div className="card-header">Scan Barcode</div>

      {error && <div className="alert alert-error">{error}</div>}

      <div className="scanner-container">
        <div id="reader"></div>
      </div>

      <div style={{ marginTop: '20px' }}>
        <button className="btn btn-secondary btn-full" onClick={handleClose}>
          Cancel
        </button>
      </div>
    </div>
  );
}

export default BarcodeScanner;
